<app-page-header
  [hideIcons]="true"
  pageName="Help/Support"
  class="desktop-toggle"
></app-page-header>

<ion-content>
  <div class="card-content">
    <i class="material-icons">help_outline</i>
    <h2>HELP & SUPPORT</h2>
    <p>
      Get the answers to your questions <br />
      both in-store & online
    </p>
  </div>

  <ion-grid>
    <ion-row>
      <ion-col size="12" size-lg="6">
        <app-resources-card [data]="FAQData"></app-resources-card>
      </ion-col>
      <ion-col size="12" size-lg="6">
        <app-resources-card [data]="ContactData"></app-resources-card>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="appVersion" class="desktop-toggle">
      <ion-col>
        <h3>APP VERSION {{appVersion}}</h3>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<app-navigation-tabs></app-navigation-tabs>
